import React, { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Hero from './sections/Hero';
import Diferenciais from './sections/Diferenciais';
import NiveisDeEnsino from './sections/NiveisDeEnsino';
import NossaEstrutura from './sections/NossaEstrutura';

const MobileVersion = () => {
  useEffect(() => {
    // Update the document title
    document.title = "Conheça o Fazer Crescer";
    
    // Optional: Restore the original title when component unmounts
    return () => {
      document.title = "React App"; // or whatever your default title is
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="mobile-view">
      <Layout showHeader={false}>  
        <Hero />
        <Diferenciais />
        <NiveisDeEnsino />
        <NossaEstrutura />
      </Layout>
    </div>
  );
};

export default MobileVersion; 